(function () {
  if (typeof document === 'undefined') return;

  function init() {
    var article = document.querySelector('.article .rte');
    if (!article) return;

    var headings = Array.prototype.filter.call(
      article.querySelectorAll('h2'),
      function (h) {
        return h.parentElement === article && h.textContent.trim().length > 0;
      }
    );

    if (headings.length < 3) return;

    var toc = document.createElement('aside');
    toc.className = 'article-toc';
    toc.setAttribute('aria-label', 'In this article');

    var title = document.createElement('p');
    title.className = 'article-toc__title';
    title.textContent = 'In this article';
    toc.appendChild(title);

    var ol = document.createElement('ol');
    var linkById = {};

    headings.forEach(function (h, i) {
      if (!h.id) {
        var slug = h.textContent
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
        h.id = slug || 'section-' + (i + 1);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      a.dataset.tocHref = h.id;
      linkById[h.id] = a;
      li.appendChild(a);
      ol.appendChild(li);
    });

    toc.appendChild(ol);
    document.body.appendChild(toc);
    requestAnimationFrame(function () {
      toc.classList.add('article-toc--ready');
    });

    if (!('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          Object.keys(linkById).forEach(function (id) {
            linkById[id].classList.remove('is-active');
          });
          var a = linkById[e.target.id];
          if (a) a.classList.add('is-active');
        });
      },
      { rootMargin: '-25% 0px -65% 0px', threshold: 0 }
    );

    headings.forEach(function (h) {
      obs.observe(h);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
